import React from 'react';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { esES, enUS, frFR, nlNL } from '@mui/x-date-pickers/locales';
import { useIntl } from 'react-intl';
import moment from 'moment';

import { TextFieldDefaultProps } from './TextFieldDefault/TextFieldDefault';

type DateTimeProps = TextFieldDefaultProps & {
  dateOnly?: boolean;
};

function DateTime(props: DateTimeProps) {
  const intl = useIntl();
  const { value, dateOnly = false, onChange, ...rest } = props;
  // create a mapping of locale to the corresponding locale object
  const localeMap: { [key: string]: any } = {
    ar: enUS,
    af: enUS,
    es: esES,
    en: enUS,
    fr: frFR,
    nl: nlNL,
    xh: enUS,
    zu: enUS,
  };
  const { localeText } = localeMap[intl.locale].components.MuiLocalizationProvider.defaultProps;
  const datePickerMomentValue = value ? moment(value) : null;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={intl.locale}
      localeText={localeText}
    >
      {dateOnly ? (
        <DatePicker
          value={datePickerMomentValue}
          views={['year', 'month', 'day']}
          onChange={(val) => {
            const formattedDate = val ? val.format('YYYY-MM-DD') : null;
            onChange(formattedDate);
          }}
          disabled={props.disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              ...rest,
            },
          }}
        />
      ) : (
        <DateTimePicker
          value={datePickerMomentValue}
          views={['year', 'month', 'day', 'hours', 'minutes']}
          onChange={onChange}
          disabled={props.disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              ...rest,
            },
          }}
        />
      )}
    </LocalizationProvider>
  );
}

export default React.memo(DateTime);
